var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"container"}},[_c('div',{staticClass:"section01"},[_c('PromiseCard'),_c('h3',{staticClass:"m-visible"},[_vm._v("자원순환센터")]),_c('RecycleCard')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }